import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export type ContainerProps = {
  secondary?: boolean
}

const containerSecondaryCss = ({ secondary }: ContainerProps) =>
  secondary &&
  css`
    background-color: ${themeGet('colors.surface.block')};
  `

const shouldForwardProp = (prop: string | number) => {
  return !['secondary'].includes(String(prop))
}

// A page shell that also wraps Header and Footer — deliberately NOT <main>
// (the content landmark is Components/Blocks/Main, or as="main" on the
// legacy pages' content column). It used to be styled.main too, which
// nested two <main> elements on every modern page.
export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex-grow: 1;
  background-color: ${themeGet('colors.surface.screen')};

  ${containerSecondaryCss}
`
